import { CommonService } from './../../../shared/services/common-service';
import { LocalStorageService } from 'angular-2-local-storage';
import { Component, OnInit, ViewChild, OnDestroy, Input } from '@angular/core';
import { DatePipe } from '@angular/common'
import { Observable, Subscription } from 'rxjs/Rx';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { animateFactory } from 'ng2-animate';
// import { ShapeOptions, CircleProgressComponent, SemiCircleProgressComponent } from 'angular2-progressbar';
import { environment } from '../../../';
import { CookieNames, BasicRoutes, CircleUIOptions, AlertMessages, Status, ApiEndpoints, ImageOptions, resourceUrl, redirectionPoints, OnlineStatus, AccessLevel, PaperTypes, StatisticsTypes } from '../../constant';
// import { DynamicClassPipe } from '@angular/common';F:\wamp64\www\school_app\src\app\shared\pipe\dynamic-class.pipe.ts

/**
 * import services
 */
import { CookieManagerService, ErrorManagerService, OrderBy, HttpClientService, CustomObserverService, BasicTimerService, BackButtonService, LoginRedirectService } from '../../../shared/';
import { TranslateService } from '@ngx-translate/core';
import { PaperSet, OnlinePaper } from '../../model'
declare var $: any;
import swal from 'sweetalert2';
import { SubscriptionInfoService } from '../../subscription-packages/subscription-info-service.service';
@Component({
  selector: 'app-paper-set',
  templateUrl: '../views/paper-set.component.html',
  styleUrls: ['../../../css/paper-set.component.css', '../../../css/paper-sets.component.css']
})
export class PaperSetComponent implements OnInit {

  @Input() paperSet: PaperSet;
  @Input() paperSetType: string;

  public resourceImage: string = resourceUrl;
  public defaultImage: string = ImageOptions.defaultImage;
  public typeIdForMyPapers: string = ApiEndpoints.paperTypeMyPapers;
  public specialView = true;
  public onlinePaper: OnlinePaper = new OnlinePaper();
  public username: boolean = false;
  public isShowing: boolean = false
  public loginModal;
  public user: any;
  public perfNowStart = performance.now();
  public disableAlert: boolean;
  public cannotBuy: boolean = false;
  public isOnlineBtnClik: boolean = false;
  public currentPaymentType : string;

  constructor(private httpClientService: HttpClientService,
    private cookieManagerService: CookieManagerService,
    private BasicTimerService: BasicTimerService,
    private ErrorManagerService: ErrorManagerService,
    public toastr: ToastsManager,
    private localStorageService: LocalStorageService,
    private trans: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private backButtonService: BackButtonService,
    private subscriptionInfoService: SubscriptionInfoService,
    private loginRedirectService: LoginRedirectService,
    private commonService : CommonService) { }

  ngOnInit() {
    if (this.paperSetType == this.typeIdForMyPapers) {
      this.specialView = false;
    }
    this.getUser();
    // tslint:disable-next-line: triple-equals
    // tslint:disable-next-line: max-line-length
    if (this.paperSetType != this.typeIdForMyPapers && (this.specialView || (this.paperSet['userInfo'] && this.paperSet['userInfo']['accessLevel'] == AccessLevel.lock))) {
      this.isShowing = true;
    }
    if (this.paperSet.startAt && this.paperSet.isOnlinePaper) {
      this.newTimeCounter(this.paperSet);
      this.listenResultTime();
    }
    this.currentPaymentType = this.localStorageService.get(CookieNames.PaymentModel)?  this.localStorageService.get(CookieNames.PaymentModel).toString() :'';

  }

  newTimeCounter(paperset) {
    this.onlinePaper.currentTime = new Date(paperset.currentTime);
    this.onlinePaper.leftSeconds = this.dateTimeDiff(new Date(paperset.startAt));
    this.onlinePaper.timeInterval = setInterval(() => {
      this.onlinePaper.currentTime.setSeconds(this.onlinePaper.currentTime.getSeconds() + 1);
      this.timeDiff_performanceNow(this.onlinePaper.leftSeconds, this.perfNowStart, paperset);
    }, 1000)
  }

  z(n) { return (n < 10 ? '0' : '') + n; }

  timeDiff_performanceNow(target, clientStart, paperset) {
    let distance = target - performance.now() + clientStart
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (hours < 0 || minutes < 0 || seconds < 0) {
      if (!this.username) {
        if (this.dateTimeDiff(new Date(paperset.blockAt)) >= 0 && paperset.isOnlinePaper && paperset.accessLevel === AccessLevel.paid) {
          this.onlinePaper.type = OnlineStatus.CANBUY.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.CANBUY.title);
          this.onlinePaper.canAccessPaper = false;
        }
        if (this.dateTimeDiff(new Date(paperset.blockAt)) >= 0 && paperset.isOnlinePaper && paperset.accessLevel === AccessLevel.free) {
          this.onlinePaper.type = OnlineStatus.START.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.START.title);
          this.onlinePaper.canAccessPaper = false;
        }
        if (this.dateTimeDiff(new Date(paperset.blockAt)) <= 0 && paperset.isOnlinePaper) {
          this.onlinePaper.type = OnlineStatus.CANTBUY.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.CANTBUY.title);//  EXAM HAS STARED CANT START NOW
          this.onlinePaper.canAccessPaper = false;
          this.cannotBuy = true;
        }
        if (this.dateTimeDiff(new Date(paperset.endAt)) <= 0 && paperset.isOnlinePaper) {
          this.onlinePaper.type = OnlineStatus.NOTDONE.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.NOTDONE.title);
          this.onlinePaper.canAccessPaper = false;
          this.cannotBuy = true;
        }
      } else {
        if ((paperset.userInfo || false).clientStatus != AccessLevel.new && !(paperset.userInfo || false).isResultsReleased) {
          this.onlinePaper.type = OnlineStatus.COMPLETE_RESULT.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.COMPLETE_RESULT.title);
          this.onlinePaper.canAccessPaper = false;
          this.cannotBuy = true;
        }
        if ((paperset.userInfo || false).clientStatus == AccessLevel.new && this.dateTimeDiff(new Date(paperset.blockAt)) >= 0) {
          this.onlinePaper.type = OnlineStatus.START.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.START.title);
          this.onlinePaper.canAccessPaper = true;
        }
        if ((paperset.userInfo || false).clientStatus == AccessLevel.new && paperset.userInfo.accessLevel === AccessLevel.lock && this.dateTimeDiff(new Date(paperset.blockAt)) >= 0) {
          this.onlinePaper.type = OnlineStatus.ONLINE_CANBUY.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.ONLINE_CANBUY.title);
          this.onlinePaper.canAccessPaper = true;
        }
        if ((paperset.userInfo || false).clientStatus == OnlineStatus.INPROGRESS && (paperset.userInfo || false).isResultsReleased) {
          this.onlinePaper.type = OnlineStatus.NOT_COMPLETE_RESULTS.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.NOT_COMPLETE_RESULTS.title);
          this.onlinePaper.canAccessPaper = false;
          this.cannotBuy = true;
        }
        if ((paperset.userInfo || false).clientStatus == OnlineStatus.COMPLETE && (paperset.userInfo || false).isResultsReleased) {
          this.onlinePaper.type = OnlineStatus.AFTER_RESULTS.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.AFTER_RESULTS.title);
          this.onlinePaper.canAccessPaper = false;
          this.cannotBuy = true;
        }
        if ((paperset.userInfo || false).clientStatus == OnlineStatus.INPROGRESS && this.dateTimeDiff(new Date(paperset.endAt)) >= 0) {
          this.onlinePaper.type = OnlineStatus.SECONDNDSTART.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.SECONDNDSTART.title);
          this.onlinePaper.canAccessPaper = true;
        }
        if ((paperset.userInfo || false).clientStatus == AccessLevel.new && this.dateTimeDiff(new Date(paperset.endAt)) <= 0) {
          this.onlinePaper.type = OnlineStatus.NOTDONE.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.NOTDONE.title);
          this.onlinePaper.canAccessPaper = false;
          this.cannotBuy = true;
        } else if ((paperset.userInfo || false).clientStatus == AccessLevel.new && this.dateTimeDiff(new Date(paperset.blockAt)) <= 0 && paperset.accessLevel == AccessLevel.free) {
          this.onlinePaper.type = OnlineStatus.CANTSTART.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.CANTSTART.title);
          this.onlinePaper.canAccessPaper = false;
        } else if ((paperset.userInfo || false).clientStatus == AccessLevel.new && this.dateTimeDiff(new Date(paperset.blockAt)) <= 0) {
          this.onlinePaper.type = OnlineStatus.ONLINE_NOTDONE.discription;
          this.onlinePaper.title = this.trans.instant(OnlineStatus.ONLINE_NOTDONE.title);
          this.onlinePaper.canAccessPaper = false;
          this.cannotBuy = true;
        }
      }
    }
    else {
      if (!(paperset.accessLevel == AccessLevel.free) && paperset.userInfo.accessLevel === AccessLevel.lock) {
        this.onlinePaper.canAccessPaper = false;
        this.onlinePaper.type = OnlineStatus.ONLINE_CANBUY.discription;
        this.onlinePaper.days = this.z(days);
        this.onlinePaper.minite = this.z(hours) + ':' + this.z(minutes) + ':' + this.z(seconds);
      }
      else {
        this.onlinePaper.canAccessPaper = false;
        this.onlinePaper.type = OnlineStatus.NOTSTART.discription;
        this.onlinePaper.days = this.z(days);
        this.onlinePaper.minite = this.z(hours) + ':' + this.z(minutes) + ':' + this.z(seconds);
      }
    }
  }

  disablePopup() {
    this.disableAlert = true;
  }

  goToResults(paperSet) {
    if (paperSet.paperSetType == StatisticsTypes.online.text) {
      this.router.navigate(['home/statistics/online-exams/' + paperSet._id]);
    }
    else if (paperSet.paperSetType == StatisticsTypes.papers.text) {
      this.router.navigate(['home/statistics/papers/' + paperSet._id]);
    }
    // else if(paperSet.paperSetType == StatisticsTypes.termTest.text){
    //   this.router.navigate(['home/statistics/term-test/'+paperSet._id]);
    // }
    else {
      this.router.navigate(['home/statistics/online-exams/' + paperSet._id]);
    }
  }

  listenResultTime(){
    let currentTime : any = new Date(this.paperSet.currentTime).getTime();
    let releasedTime : any = new Date(this.paperSet.resultReleaseAt).getTime();
    let resultTimeOut = releasedTime-currentTime >= 0 ? releasedTime-currentTime : 0;
    setTimeout( () => {
      this.paperSet.userInfo.isResultsReleased = true;
    }, resultTimeOut+4000);
  }

  ngAfterViewInit() {
    this.loginModal = $('#log-in-pop');
  }

  onlineStart(paperset) {
    this.isOnlineBtnClik = true;
    let oldStartTime : any = new Date(paperset.startAt) ;
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPapers, {
      [ApiEndpoints.setid]: this.paperSet._id,
    }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      paperset.startAt =  new Date(response.papers[0].paperSet.startAt);
      if ((paperset.startAt -oldStartTime) > 0) {
        this.onlinePaper.type = "REFRESH_TIME";
        this.onlinePaper.canAccessPaper = false;
        this.onlineAlert(paperset,false);
        this.newTimeCounter(paperset)
      }
      else if((paperset.startAt -oldStartTime) <= 0 && this.onlinePaper.canAccessPaper) { // tslint:disable-line
        this.onlineAlert(paperset, true);
        this.cookieManagerService.setCookie(CookieNames.paperTitle, '', false, 1);
        this.cookieManagerService.setCookie(CookieNames.onlineExam, OnlineStatus.ONLINE, false, 1);
        this.cookieManagerService.setCookie(CookieNames.paperSetKey, paperset._id, false, 1);
      }
    }, error => {
      this.ErrorManagerService.setError(error);
    });


  }

  /**
  * Payment popup
  */
  paperSetRouter(paperset) {
    let param = this.route.snapshot.params['filter'];
    param ? this.backButtonService.setPaperType(param) : this.backButtonService.setPaperType('revision');

    this.getUser();
    this.cookieManagerService.setCookie(CookieNames.paperSet, paperset, true, 1);
    this.cookieManagerService.setCookie(CookieNames.paperSettitle, paperset.title, false, 1);
    let userSubscriptionPackageId = this.subscriptionInfoService.getUserSubscribedPackage();

    if (paperset.accessLevel === AccessLevel.free && !this.username) {
      if (paperset.isOnlinePaper) {
        if (this.dateTimeDiff(new Date(paperset.blockAt)) >= 0 && this.onlinePaper.type === OnlineStatus.START.discription) {
          this.loginRedirectService.setRedirectPoint("FreePaper");
          this.loginRedirectService.setRedirectPaper('home/exams/' + paperset._id + '/papers');
        }
      } else {
        this.loginRedirectService.setRedirectPoint(redirectionPoints.freePaper);
        this.loginRedirectService.setRedirectPaper('home/exams/' + paperset._id + '/papers');
      }
      $('#log-in-pop').modal('show');
      return;
    }
    if (this.username && paperset.accessLevel === AccessLevel.free && !this.paperSet.isOnlinePaper) {
      this.router.navigate(['home/exams/' + paperset._id + '/papers']);
      this.cookieManagerService.setCookie(CookieNames.onlineExam, OnlineStatus.NOTONLINE, false, 1)
    }
    if (this.username && paperset.userInfo.accessLevel === AccessLevel.unlock && !this.paperSet.isOnlinePaper) {
      this.router.navigate(['home/exams/' + paperset._id + '/papers']);
      this.cookieManagerService.setCookie(CookieNames.onlineExam, OnlineStatus.NOTONLINE, false, 1)
    }

    if (paperset.userInfo.accessLevel === Status.lock) {
      if (paperset.isOnlinePaper && !(this.dateTimeDiff(new Date(paperset.blockAt)) >= 0)) {
        this.onlinePaper.type = this.dateTimeDiff(new Date(paperset.endAt)) >= 0 ? OnlineStatus.CANTBUY.discription : OnlineStatus.NOTDONE.discription
        this.onlinePaper.canAccessPaper = false;
        this.onlineAlert(paperset, false);
        return;
      }
      //this.paidPaperSets(paperset);
      if (!this.disableAlert) {
        this.onlineAlert(paperset, false);
      }
      this.disableAlert = false;
      if(this.commonService.isDialogMobileNumber(this.user.username) && !paperset.subscriptions.includes(userSubscriptionPackageId) ){
        if( paperset.paperSetType !="ONLINE_EXAM"){
          $('#packages-pop').modal('show');
        }
        else{


        }
      }

      return;
    }
    if (paperset.isOnlinePaper) {
      if (this.onlinePaper.canAccessPaper && this.isOnlineBtnClik) { // tslint:disable-line
        this.onlineAlert(paperset, true);
        this.cookieManagerService.setCookie(CookieNames.paperTitle, '', false, 1);
        this.cookieManagerService.setCookie(CookieNames.onlineExam, OnlineStatus.ONLINE, false, 1);
        this.cookieManagerService.setCookie(CookieNames.paperSetKey, paperset._id, false, 1);
        this.isOnlineBtnClik = false;
        return;
      }
      if (!this.disableAlert) {
        this.onlineAlert(paperset, false);
      }
      this.disableAlert = false;
      return;
    }
    else {
      if ((this.username && paperset.accessLevel === AccessLevel.free) || (this.username && paperset.userInfo.accessLevel === AccessLevel.unlock) || (this.username && (paperset.userInfo || {}).accessLevel === AccessLevel.unlock && this.onlinePaper.canAccessPaper)) {
        this.router.navigate(['home/exams/' + paperset._id + '/papers']);
        this.cookieManagerService.setCookie(CookieNames.onlineExam, OnlineStatus.NOTONLINE, false, 1);
      } else {
        return;
      }

    }
  }

  dateTimeDiff(target: Date): number {
    return (target.getTime() - this.onlinePaper.currentTime.getTime());
  }


  onlineAlert(paperset, canGo) {
    let that = this;
    // let resultReleaseAt = new Date(paperset.userInfo.resultReleaseAt);
    let resultReleaseAt = new Date(paperset.resultReleaseAt);
    let realDate = new Date(paperset.startAt);
    this.onlinePaper.startAt = realDate.toLocaleDateString().replace(new RegExp('/', 'g'), '-') + ',' + that.trans.instant('TIME') + (new Date(paperset.startAt)).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    this.onlinePaper.resultReleaseAt = resultReleaseAt.toLocaleDateString().replace(new RegExp('/', 'g'), '-') + that.trans.instant('DAYS') + ',' + that.trans.instant('TIME') + resultReleaseAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    let notstart = `<h5>${that.trans.instant('ONLINE_PAPER_STATE')}<br></h5><strong>${that.trans.instant('EXAM_START_DATE') + this.onlinePaper.startAt}</strong>`;
    let startpaper = `<h5>${that.trans.instant('ONLINE_PAPER_STATE')}<br></h5>`;
    let start2ndpaper = `<h5>${that.trans.instant('ONLINE_PAPER_STATE')}<br></h5><strong>${that.trans.instant('START_SECOND_PART')}</strong>`;
    let waitforresults = `විභාගය අවසන්, ඔබගේ ප්‍රතිඵල <strong>${this.onlinePaper.resultReleaseAt}</strong> නිකුත්වනු ඇත.`;
    let notDone = that.trans.instant('ONLY_RELASE_FOR_PARTICIPATERS');
    let results = paperset.userInfo && paperset.userInfo.isResultsReleased && paperset.userInfo.clientStatus == OnlineStatus.COMPLETE ? `${that.trans.instant('GOTO_REPORTS')}` : that.trans.instant('NOT_COMPLETE_CORRECTLY');
    let cantbuy = that.trans.instant('CANNOT_BUY');
    let cantstart = `<h5>${that.trans.instant('PAPER_BLOCKED')}<br></h5>`;
    let canbuy = `<h5>${that.trans.instant('ONLINE_PAID_LOCKED')}<br></h5><br></h5><strong>${that.trans.instant('EXAM_START_DATE') + this.onlinePaper.startAt}</strong>`;
    let refreshTime = `<h5>${that.trans.instant('ONLINE_PAPER_POSTPONE1')+ (new Date(paperset.startAt)).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) + that.trans.instant('ONLINE_PAPER_POSTPONE2')}<br></h5>`;
    const EXAM_STATE = {
      NOTSTART: notstart,
      START: startpaper,
      SECONDNDSTART: start2ndpaper,
      END: waitforresults,
      NOTDONE: notDone,
      RESULT: results,
      CANTBUY: cantbuy,
      CANBUY: canbuy,
      CANTSTART: cantstart,
      REFRESH_TIME : refreshTime,
    }
    if (!this.onlinePaper.type) {
      return
    }
    swal({
      title: paperset.title,
      html: EXAM_STATE[this.onlinePaper.type],
      showCancelButton: false,
      showConfirmButton: canGo,
      cancelButtonColor: '#f39c12',
      customClass: 'online-exam-alert',
      confirmButtonText: that.trans.instant('START_PAPER'),
    }).then(function () {
      if (paperset.userInfo) {
        that.router.navigate(['/home/exams/' + paperset._id + '/papers']);
      }
    }, function (dismiss) {

    })
  }

  /**
  * kauhsalya
  * 2017-0-11
  * get user papers according to the user status
  */
  getUser() {
    let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);

    this.user = userObj ? JSON.parse(userObj.toString()) : null;
    if (this.user) {
      this.username = true;
    }
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-sets/components/paper-set.component.ts